<div class="app-isf-ocr-quick-fix-supplier-details">
  <div class="app-isf-ocr-quick-fix-supplier-details__header">
    <div class="app-isf-ocr-quick-fix-supplier-details__header__left">
      <p class="app-isf-ocr-quick-fix-supplier-details__header__title">
        {{ "INFO.SP.TITLE" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.SP.SUB_TITLE' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-supplier-details__row">
    <p class="app-isf-ocr-quick-fix-supplier-details__text m-0">
      {{ "INFO.SP.SUB_TITLE" | translate }}
    </p>
  </div>

  <div class="app-isf-ocr-quick-fix-supplier-details__row">
    <app-section-form-block-layout
      *ngIf="!!filteredSupplierFields"
      [formGroup]="formGroup"
      [fields]="filteredSupplierFields"
      [displayFields]="supplierDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(supplierFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <app-control-wrapper edit-block-body [control]="formGroup.get('name')" [isShowHelper]="false" [errors]="displayErrors">
        <label for="name" control-label>{{ "LABELS.NAME" | translate }}</label>
        <app-search-wrapper control-wrapper [items]="entities" [loading]="companyLoading" (callback)="changeAddress($event)">
          <input
            type="text"
            [formControl]="formGroup.get('name')"
            class="form-control"
            id="name"
            name="name"
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
            [mask]="'F*'"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          />
        </app-search-wrapper>
      </app-control-wrapper>

      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.SELLER"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-supplier-details__hr" />

    <div class="app-isf-ocr-quick-fix-supplier-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
